/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentDetailsDebitOrderViewModel } from './PaymentDetailsDebitOrderViewModel';
import {
    PaymentDetailsDebitOrderViewModelFromJSON,
    PaymentDetailsDebitOrderViewModelFromJSONTyped,
    PaymentDetailsDebitOrderViewModelToJSON,
} from './PaymentDetailsDebitOrderViewModel';
import type { PaymentDetailsInternalTransferViewModel } from './PaymentDetailsInternalTransferViewModel';
import {
    PaymentDetailsInternalTransferViewModelFromJSON,
    PaymentDetailsInternalTransferViewModelFromJSONTyped,
    PaymentDetailsInternalTransferViewModelToJSON,
} from './PaymentDetailsInternalTransferViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsRecurringContributionViewModel
 */
export interface PaymentDetailsRecurringContributionViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsRecurringContributionViewModel
     */
    paymentCategoryId: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsRecurringContributionViewModel
     */
    totalAmount: number;
    /**
     * 
     * @type {PaymentDetailsDebitOrderViewModel}
     * @memberof PaymentDetailsRecurringContributionViewModel
     */
    debitOrder?: PaymentDetailsDebitOrderViewModel;
    /**
     * 
     * @type {PaymentDetailsInternalTransferViewModel}
     * @memberof PaymentDetailsRecurringContributionViewModel
     */
    internalTransfer?: PaymentDetailsInternalTransferViewModel;
}

/**
 * Check if a given object implements the PaymentDetailsRecurringContributionViewModel interface.
 */
export function instanceOfPaymentDetailsRecurringContributionViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentCategoryId" in value;
    isInstance = isInstance && "totalAmount" in value;

    return isInstance;
}

export function PaymentDetailsRecurringContributionViewModelFromJSON(json: any): PaymentDetailsRecurringContributionViewModel {
    return PaymentDetailsRecurringContributionViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsRecurringContributionViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsRecurringContributionViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentCategoryId': json['PaymentCategoryId'],
        'totalAmount': json['TotalAmount'],
        'debitOrder': !exists(json, 'DebitOrder') ? undefined : PaymentDetailsDebitOrderViewModelFromJSON(json['DebitOrder']),
        'internalTransfer': !exists(json, 'InternalTransfer') ? undefined : PaymentDetailsInternalTransferViewModelFromJSON(json['InternalTransfer']),
    };
}

export function PaymentDetailsRecurringContributionViewModelToJSON(value?: PaymentDetailsRecurringContributionViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PaymentCategoryId': value.paymentCategoryId,
        'TotalAmount': value.totalAmount,
        'DebitOrder': PaymentDetailsDebitOrderViewModelToJSON(value.debitOrder),
        'InternalTransfer': PaymentDetailsInternalTransferViewModelToJSON(value.internalTransfer),
    };
}

